import LessonAreaListContainer from './container';
import LessonAreaList from './LessonAreaList';

export { LessonAreaList };
export default LessonAreaListContainer;
